import { render, staticRenderFns } from "./PsItemMenu.vue?vue&type=template&id=41fb6074&scoped=true&"
import script from "./PsItemMenu.vue?vue&type=script&lang=js&"
export * from "./PsItemMenu.vue?vue&type=script&lang=js&"
import style0 from "./PsItemMenu.vue?vue&type=style&index=0&id=41fb6074&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41fb6074",
  null
  
)

export default component.exports